import React, { useState } from 'react';
import { Divider, Typography } from 'antd';
import { FormInstance } from 'antd/lib/form';
// Helpers
import {
  ExternalTalentFormValues,
  getExtTalentPlaceFields,
  PendingPlaceFields,
} from 'helpers/externalTalents';
// Components
import LocationCard from './LocationCard/LocationCard';

const { Title } = Typography;

type LocationSectionProps = {
  disableBrowserAutocomplete?: boolean;
  form: FormInstance<ExternalTalentFormValues>;
};

const LocationSection = ({
  disableBrowserAutocomplete = false,
  form,
}: LocationSectionProps): JSX.Element => {
  const [pendingCurrentLocation, setPendingCurrentLocation] =
    useState<PendingPlaceFields | null>(null);
  const [pendingHomeLocation, setPendingHomeLocation] =
    useState<PendingPlaceFields | null>(null);

  const handleApplyCurrentLocation = () => {
    if (!pendingCurrentLocation) {
      return;
    }

    form.setFieldsValue(pendingCurrentLocation);
    setPendingCurrentLocation(null);
  };

  const handleApplyHomeLocation = () => {
    if (!pendingHomeLocation) {
      return;
    }

    form.setFieldsValue(pendingHomeLocation);
    setPendingHomeLocation(null);
  };

  return (
    <>
      <Divider />

      <Title level={5}>Location</Title>

      <LocationCard
        cityFieldLabel="City"
        cityFieldName="city"
        countryFieldLabel="Country"
        countryFieldName="country"
        currentPendingLocation={pendingCurrentLocation}
        disableBrowserAutocomplete={disableBrowserAutocomplete}
        onApplySuggestion={handleApplyCurrentLocation}
        onDismissSuggestion={() => setPendingCurrentLocation(null)}
        onPlaceSelect={(placeDetails) =>
          setPendingCurrentLocation(
            getExtTalentPlaceFields(placeDetails, 'city')
          )
        }
        onSearchChange={() => setPendingCurrentLocation(null)}
        placeFieldName="citySearch"
        placeLabel="Current location via API"
        placePlaceholder="Search city, state, country"
        searchInputName="ext-talent-current-location-search"
        searchPrefix="ext-talent-current-location"
        stateFieldLabel="State"
        stateFieldName="state"
      />

      <LocationCard
        cityFieldLabel="Home city"
        cityFieldName="homeCity"
        countryFieldLabel="Home country"
        countryFieldName="homeCountry"
        currentPendingLocation={pendingHomeLocation}
        disableBrowserAutocomplete={disableBrowserAutocomplete}
        onApplySuggestion={handleApplyHomeLocation}
        onDismissSuggestion={() => setPendingHomeLocation(null)}
        onPlaceSelect={(placeDetails) =>
          setPendingHomeLocation(getExtTalentPlaceFields(placeDetails, 'home'))
        }
        onSearchChange={() => setPendingHomeLocation(null)}
        placeFieldName="homeLocationSearch"
        placeLabel="Home location via API"
        placePlaceholder="Search home city, state, country"
        searchInputName="ext-talent-home-location-search"
        searchPrefix="ext-talent-home-location"
        stateFieldLabel="Home state"
        stateFieldName="homeState"
      />
    </>
  );
};

export default LocationSection;
